module.exports = __webpack_public_path__ + "8ba155ae396331b44bf228f95f8c1a7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/08_LC_05.png
// module id = 108
// module chunks = 0